var map = {
	"./about/alex-wieck": 571,
	"./about/alex-wieck.jpg": 571,
	"./about/banner-prop": 475,
	"./about/banner-prop.png": 475,
	"./about/banner-prop.svg": 994,
	"./about/cta": 572,
	"./about/cta.jpg": 572,
	"./about/hero": 573,
	"./about/hero.jpg": 573,
	"./about/hero2": 574,
	"./about/hero2.jpg": 574,
	"./about/kenneth-harmon": 575,
	"./about/kenneth-harmon.jpg": 575,
	"./about/lina-xing": 576,
	"./about/lina-xing.jpg": 576,
	"./about/magdalena-kusz": 577,
	"./about/magdalena-kusz.jpg": 577,
	"./about/matt-reason": 191,
	"./about/matt-reason.jpg": 191,
	"./about/max-doyle": 578,
	"./about/max-doyle.png": 578,
	"./about/max-schmidt": 579,
	"./about/max-schmidt.jpg": 579,
	"./about/max-volsky": 580,
	"./about/max-volsky-and-max-schmidt": 476,
	"./about/max-volsky-and-max-schmidt.png": 476,
	"./about/max-volsky.jpg": 580,
	"./about/quote-prop": 581,
	"./about/quote-prop.png": 581,
	"./about/ray-marchand": 324,
	"./about/ray-marchand.jpg": 324,
	"./about/wali-rahman": 582,
	"./about/wali-rahman.jpg": 582,
	"./about_employee/boston": 583,
	"./about_employee/boston.png": 583,
	"./about_employee/nyc": 584,
	"./about_employee/nyc.png": 584,
	"./about_employee/vermont_1": 585,
	"./about_employee/vermont_1.png": 585,
	"./about_employee/vermont_2": 586,
	"./about_employee/vermont_2.png": 586,
	"./attorney/footer": 587,
	"./attorney/footer.jpg": 587,
	"./attorney/hero": 192,
	"./attorney/hero.png": 192,
	"./attorney_resource_center/attorney-guide-book": 325,
	"./attorney_resource_center/attorney-guide-book-center": 588,
	"./attorney_resource_center/attorney-guide-book-center.png": 588,
	"./attorney_resource_center/attorney-guide-book.png": 325,
	"./attorney_resource_center/litigation-finance-book": 193,
	"./attorney_resource_center/litigation-finance-book.png": 193,
	"./attorney_resource_center/plaintiff-guide-book": 589,
	"./attorney_resource_center/plaintiff-guide-book-center": 185,
	"./attorney_resource_center/plaintiff-guide-book-center.png": 185,
	"./attorney_resource_center/plaintiff-guide-book.png": 589,
	"./backgrounds/dashboard-bg-strip": 326,
	"./backgrounds/dashboard-bg-strip.png": 326,
	"./backgrounds/diamond-array": 327,
	"./backgrounds/diamond-array-dark-purple": 303,
	"./backgrounds/diamond-array-dark-purple.png": 303,
	"./backgrounds/diamond-array-gray": 188,
	"./backgrounds/diamond-array-gray.png": 188,
	"./backgrounds/diamond-array-purple": 69,
	"./backgrounds/diamond-array-purple.png": 69,
	"./backgrounds/diamond-array.png": 327,
	"./backgrounds/purple-bg-strip": 328,
	"./backgrounds/purple-bg-strip.png": 328,
	"./barometer/disclosure": 329,
	"./barometer/disclosure.png": 329,
	"./barometer/lit-fin-201": 330,
	"./barometer/lit-fin-201.png": 330,
	"./barometer/lit-fin-ethics": 331,
	"./barometer/lit-fin-ethics.png": 331,
	"./barometer/meta-image": 590,
	"./barometer/meta-image.png": 590,
	"./barometer/report-cover": 332,
	"./barometer/report-cover.jpg": 332,
	"./barometer/thumbnail": 310,
	"./barometer/thumbnail.jpg": 310,
	"./barometer_linkedin/header-wave": 194,
	"./barometer_linkedin/header-wave.png": 194,
	"./barometer_linkedin/purple-ombre-background": 333,
	"./barometer_linkedin/purple-ombre-background.png": 333,
	"./barometer_linkedin/report-cover": 334,
	"./barometer_linkedin/report-cover.png": 334,
	"./barometer_linkedin/wave": 335,
	"./barometer_linkedin/wave.png": 335,
	"./case_studies/hero": 336,
	"./case_studies/hero.jpg": 336,
	"./cases/cta": 337,
	"./cases/cta.jpg": 337,
	"./cases/hero": 338,
	"./cases/hero.png": 338,
	"./email/mr_sig": 591,
	"./email/mr_sig.png": 591,
	"./email/rm_sig": 592,
	"./email/rm_sig.png": 592,
	"./faq/cta": 593,
	"./faq/cta.jpg": 593,
	"./faq/hero": 594,
	"./faq/hero.jpg": 594,
	"./home/bloomberg-law": 339,
	"./home/bloomberg-law.png": 339,
	"./home/cta": 595,
	"./home/cta.jpg": 595,
	"./home/financial-times": 340,
	"./home/financial-times.png": 340,
	"./home/funnel": 596,
	"./home/funnel.png": 596,
	"./home/hero": 232,
	"./home/hero.jpg": 995,
	"./home/hero.png": 232,
	"./home/law": 341,
	"./home/law-360": 342,
	"./home/law-360.png": 342,
	"./home/law.png": 341,
	"./home/new-york-times": 343,
	"./home/new-york-times.png": 343,
	"./home/purple-background": 85,
	"./home/purple-background.png": 85,
	"./home/wsj": 344,
	"./home/wsj.png": 344,
	"./icons/Thumbs.db": 996,
	"./icons/ajax-loader": 304,
	"./icons/ajax-loader-spotlight": 597,
	"./icons/ajax-loader-spotlight.gif": 597,
	"./icons/ajax-loader.gif": 304,
	"./icons/angel-white": 318,
	"./icons/angel-white.png": 318,
	"./icons/arrow": 131,
	"./icons/arrow-down-black": 345,
	"./icons/arrow-down-black.png": 345,
	"./icons/arrow-purple": 207,
	"./icons/arrow-purple.png": 207,
	"./icons/arrow.png": 131,
	"./icons/award": 598,
	"./icons/award-icon": 346,
	"./icons/award-icon.png": 346,
	"./icons/award.png": 598,
	"./icons/bar-chart-trend-up": 308,
	"./icons/bar-chart-trend-up.png": 308,
	"./icons/bill": 599,
	"./icons/bill.png": 599,
	"./icons/buildings": 311,
	"./icons/buildings.png": 311,
	"./icons/business-area": 58,
	"./icons/business-area.png": 58,
	"./icons/business-checklist": 600,
	"./icons/business-checklist-gray": 601,
	"./icons/business-checklist-gray.png": 601,
	"./icons/business-checklist.png": 600,
	"./icons/business-strategy": 602,
	"./icons/business-strategy.png": 602,
	"./icons/calculator-icon": 347,
	"./icons/calculator-icon.png": 347,
	"./icons/calendar": 603,
	"./icons/calendar-icon": 348,
	"./icons/calendar-icon.png": 348,
	"./icons/calendar.png": 603,
	"./icons/card-icon": 349,
	"./icons/card-icon.png": 349,
	"./icons/career": 604,
	"./icons/career.png": 604,
	"./icons/check": 195,
	"./icons/check-done": 605,
	"./icons/check-done.png": 605,
	"./icons/check.png": 195,
	"./icons/checkmark": 114,
	"./icons/checkmark-black": 196,
	"./icons/checkmark-black.png": 196,
	"./icons/checkmark-in-shield": 133,
	"./icons/checkmark-in-shield-small": 606,
	"./icons/checkmark-in-shield-small.png": 606,
	"./icons/checkmark-in-shield.png": 133,
	"./icons/checkmark-white": 209,
	"./icons/checkmark-white-in-purple-background": 105,
	"./icons/checkmark-white-in-purple-background.png": 105,
	"./icons/checkmark-white.png": 209,
	"./icons/checkmark.png": 114,
	"./icons/cheers": 607,
	"./icons/cheers.png": 607,
	"./icons/chess-piece": 608,
	"./icons/chess-piece.png": 608,
	"./icons/chevron-left": 350,
	"./icons/chevron-left.svg": 350,
	"./icons/chevron-right": 351,
	"./icons/chevron-right.svg": 351,
	"./icons/circle-dollar": 609,
	"./icons/circle-dollar.png": 609,
	"./icons/close": 610,
	"./icons/close.png": 610,
	"./icons/columns": 611,
	"./icons/columns-gray": 612,
	"./icons/columns-gray.png": 612,
	"./icons/columns.png": 611,
	"./icons/dark-ajax-loader": 352,
	"./icons/dark-ajax-loader.gif": 352,
	"./icons/dark-bg-ajax-loader": 613,
	"./icons/dark-bg-ajax-loader.gif": 613,
	"./icons/deal": 353,
	"./icons/deal.png": 353,
	"./icons/desktop": 614,
	"./icons/desktop-smartphone": 615,
	"./icons/desktop-smartphone-gray": 616,
	"./icons/desktop-smartphone-gray.png": 616,
	"./icons/desktop-smartphone.png": 615,
	"./icons/desktop.png": 614,
	"./icons/document-folded": 309,
	"./icons/document-folded.png": 309,
	"./icons/document-search": 617,
	"./icons/document-search.png": 617,
	"./icons/dollar-sign": 84,
	"./icons/dollar-sign.png": 84,
	"./icons/donut-chart": 618,
	"./icons/donut-chart.png": 618,
	"./icons/down-arrow-active": 619,
	"./icons/down-arrow-active.png": 619,
	"./icons/download": 620,
	"./icons/download.png": 620,
	"./icons/facebook-black": 621,
	"./icons/facebook-black.png": 621,
	"./icons/facebook-white": 315,
	"./icons/facebook-white.png": 315,
	"./icons/faq": 312,
	"./icons/faq.png": 312,
	"./icons/fast": 622,
	"./icons/fast.png": 622,
	"./icons/file-download": 623,
	"./icons/file-download.png": 623,
	"./icons/gavel": 99,
	"./icons/gavel.png": 99,
	"./icons/government": 100,
	"./icons/government-gray": 624,
	"./icons/government-gray.png": 624,
	"./icons/government.png": 100,
	"./icons/graph-icon": 354,
	"./icons/graph-icon.png": 354,
	"./icons/hand-money": 237,
	"./icons/hand-money.png": 237,
	"./icons/idea-icon": 355,
	"./icons/idea-icon.png": 355,
	"./icons/info": 210,
	"./icons/info.svg": 210,
	"./icons/left-arrow": 101,
	"./icons/left-arrow-white": 356,
	"./icons/left-arrow-white.png": 356,
	"./icons/left-arrow.png": 101,
	"./icons/linkedin-black": 625,
	"./icons/linkedin-black.png": 625,
	"./icons/linkedin-white": 317,
	"./icons/linkedin-white.png": 317,
	"./icons/loading": 477,
	"./icons/loading.gif": 507,
	"./icons/loading.png": 477,
	"./icons/lock": 478,
	"./icons/lock.png": 478,
	"./icons/lock.svg": 238,
	"./icons/medal": 626,
	"./icons/medal.png": 626,
	"./icons/menu": 184,
	"./icons/menu.png": 184,
	"./icons/negative_status": 627,
	"./icons/negative_status.png": 627,
	"./icons/neutral_status": 628,
	"./icons/neutral_status.png": 628,
	"./icons/page": 357,
	"./icons/page.png": 357,
	"./icons/people": 239,
	"./icons/people.png": 239,
	"./icons/person-in-courthouse": 235,
	"./icons/person-in-courthouse.png": 235,
	"./icons/portfolio": 189,
	"./icons/portfolio-funding": 240,
	"./icons/portfolio-funding.png": 240,
	"./icons/portfolio.png": 189,
	"./icons/positive_status": 629,
	"./icons/positive_status.png": 629,
	"./icons/presentation-deck": 630,
	"./icons/presentation-deck.png": 630,
	"./icons/purple-diamond": 631,
	"./icons/purple-diamond.png": 631,
	"./icons/right-arrow": 102,
	"./icons/right-arrow-white": 358,
	"./icons/right-arrow-white.png": 358,
	"./icons/right-arrow.png": 102,
	"./icons/safe-case": 113,
	"./icons/safe-case.png": 113,
	"./icons/search-a": 359,
	"./icons/search-a-gray": 632,
	"./icons/search-a-gray.png": 632,
	"./icons/search-a.png": 359,
	"./icons/skinny-arrow": 67,
	"./icons/skinny-arrow.png": 67,
	"./icons/suitcase-money": 241,
	"./icons/suitcase-money.png": 241,
	"./icons/task-tick": 360,
	"./icons/task-tick-gray": 633,
	"./icons/task-tick-gray.png": 633,
	"./icons/task-tick.png": 360,
	"./icons/tie": 634,
	"./icons/tie-gray": 635,
	"./icons/tie-gray.png": 635,
	"./icons/tie.png": 634,
	"./icons/time-icon": 361,
	"./icons/time-icon.png": 361,
	"./icons/twitter-black": 636,
	"./icons/twitter-black.png": 636,
	"./icons/twitter-white": 316,
	"./icons/twitter-white.png": 316,
	"./icons/two-people": 231,
	"./icons/two-people.png": 231,
	"./icons/up-arrow": 314,
	"./icons/up-arrow-active": 637,
	"./icons/up-arrow-active.png": 637,
	"./icons/up-arrow.png": 314,
	"./icons/upload": 638,
	"./icons/upload.png": 638,
	"./icons/usa-and-california-flag": 313,
	"./icons/usa-and-california-flag.png": 313,
	"./icons/wallet": 639,
	"./icons/wallet.png": 639,
	"./icons/web": 640,
	"./icons/web-banking": 190,
	"./icons/web-banking-gray": 641,
	"./icons/web-banking-gray.png": 641,
	"./icons/web-banking.png": 190,
	"./icons/web.png": 640,
	"./icons/white-close": 127,
	"./icons/white-close.png": 127,
	"./icons/white-diamond": 362,
	"./icons/white-diamond.png": 362,
	"./icons/x-icon": 306,
	"./icons/x-icon.png": 306,
	"./in_house/ebook": 321,
	"./in_house/ebook.png": 321,
	"./in_house/footer": 363,
	"./in_house/footer.jpg": 363,
	"./in_house/guide": 236,
	"./in_house/guide.png": 236,
	"./in_house/hero": 364,
	"./in_house/hero.jpg": 364,
	"./invest/footer": 642,
	"./invest/footer.jpg": 642,
	"./invest/hero": 365,
	"./invest/hero.jpg": 365,
	"./invest/historical-performance": 366,
	"./invest/historical-performance.png": 366,
	"./invest/institutional-strategy": 367,
	"./invest/institutional-strategy.png": 367,
	"./invest/uncorrelated-asset": 368,
	"./invest/uncorrelated-asset.png": 368,
	"./investor_dashboard/bulb": 233,
	"./investor_dashboard/bulb.png": 233,
	"./investor_dashboard/bulb.svg": 997,
	"./investors/cta": 643,
	"./investors/cta.jpg": 643,
	"./investors/follow-case": 644,
	"./investors/follow-case.png": 644,
	"./investors/headshot": 645,
	"./investors/headshot.png": 645,
	"./investors/hero": 646,
	"./investors/hero.jpg": 646,
	"./investors/investor-dashboard": 647,
	"./investors/investor-dashboard.png": 647,
	"./investors/streamlined-registration": 648,
	"./investors/streamlined-registration.png": 648,
	"./law_firm_funding/cta": 369,
	"./law_firm_funding/cta.jpg": 369,
	"./law_firm_funding/hero": 370,
	"./law_firm_funding/hero.jpg": 370,
	"./litigation_finance_101/cta": 649,
	"./litigation_finance_101/cta.jpg": 649,
	"./litigation_finance_101/hero": 371,
	"./litigation_finance_101/hero.jpg": 371,
	"./logos/abajournal-logo-white": 186,
	"./logos/abajournal-logo-white.png": 186,
	"./logos/above-the-law-logo-white": 650,
	"./logos/above-the-law-logo-white.png": 650,
	"./logos/am-trust-logo": 651,
	"./logos/am-trust-logo.png": 651,
	"./logos/bloomberg-law-logo-black": 479,
	"./logos/bloomberg-law-logo-black.png": 479,
	"./logos/bloomberg-law-logo-black.svg": 508,
	"./logos/bloomberg-logo-black": 372,
	"./logos/bloomberg-logo-black.png": 372,
	"./logos/bloomberg-logo-white": 129,
	"./logos/bloomberg-logo-white-small": 652,
	"./logos/bloomberg-logo-white-small.png": 652,
	"./logos/bloomberg-logo-white.png": 129,
	"./logos/business-insider-logo-black": 373,
	"./logos/business-insider-logo-black.png": 373,
	"./logos/cnbc-logo-white": 653,
	"./logos/cnbc-logo-white.png": 653,
	"./logos/crains-logo-white": 654,
	"./logos/crains-logo-white-testimonial": 655,
	"./logos/crains-logo-white-testimonial.png": 655,
	"./logos/crains-logo-white.png": 654,
	"./logos/esquire-logo": 656,
	"./logos/esquire-logo.png": 656,
	"./logos/forbes-logo-black": 374,
	"./logos/forbes-logo-black.png": 374,
	"./logos/forbes-logo-white": 130,
	"./logos/forbes-logo-white-small": 657,
	"./logos/forbes-logo-white-small.png": 657,
	"./logos/forbes-logo-white-testimonial": 658,
	"./logos/forbes-logo-white-testimonial.png": 658,
	"./logos/forbes-logo-white.png": 130,
	"./logos/ft-logo-black": 659,
	"./logos/ft-logo-black.png": 659,
	"./logos/glg-logo-black": 660,
	"./logos/glg-logo-black.png": 660,
	"./logos/law.com-logo": 661,
	"./logos/law.com-logo-black": 662,
	"./logos/law.com-logo-black.png": 662,
	"./logos/law.com-logo.png": 661,
	"./logos/law360-logo-black": 663,
	"./logos/law360-logo-black.png": 663,
	"./logos/law360-logo-white": 187,
	"./logos/law360-logo-white-small": 664,
	"./logos/law360-logo-white-small.png": 664,
	"./logos/law360-logo-white.png": 187,
	"./logos/lexshares": 64,
	"./logos/lexshares-black": 80,
	"./logos/lexshares-black.png": 80,
	"./logos/lexshares-diamond": 375,
	"./logos/lexshares-diamond.png": 375,
	"./logos/lexshares-logo-icon": 305,
	"./logos/lexshares-logo-icon.png": 305,
	"./logos/lexshares-small": 307,
	"./logos/lexshares-small.png": 307,
	"./logos/lexshares.png": 64,
	"./logos/msbnc-black": 665,
	"./logos/msbnc-black.jpg": 665,
	"./logos/msnb-logo-black": 376,
	"./logos/msnb-logo-black.png": 376,
	"./logos/msnbc-logo-black": 666,
	"./logos/msnbc-logo-black.png": 666,
	"./logos/msnbc-logo-white": 377,
	"./logos/msnbc-logo-white-small": 667,
	"./logos/msnbc-logo-white-small.png": 667,
	"./logos/msnbc-logo-white.png": 377,
	"./logos/new-york-times-logo-black": 668,
	"./logos/new-york-times-logo-black.png": 668,
	"./logos/original-lexshares-logo": 669,
	"./logos/original-lexshares-logo.png": 669,
	"./logos/press-logo-attorneys": 670,
	"./logos/press-logo-attorneys-white": 378,
	"./logos/press-logo-attorneys-white.png": 378,
	"./logos/press-logo-attorneys.png": 670,
	"./logos/press-logo-businesses-white": 379,
	"./logos/press-logo-businesses-white.png": 379,
	"./logos/press-logo-home": 671,
	"./logos/press-logo-home.png": 671,
	"./logos/press-logo-in-house": 380,
	"./logos/press-logo-in-house.png": 380,
	"./logos/press-logo-investors": 672,
	"./logos/press-logo-investors-black": 381,
	"./logos/press-logo-investors-black.svg": 381,
	"./logos/press-logo-investors.png": 672,
	"./logos/press-logo-plaintiffs": 673,
	"./logos/press-logo-plaintiffs.png": 673,
	"./logos/press-logo-spread-persona": 674,
	"./logos/press-logo-spread-persona-white": 320,
	"./logos/press-logo-spread-persona-white.png": 320,
	"./logos/press-logo-spread-persona.png": 674,
	"./logos/pymnts-logo-white": 675,
	"./logos/pymnts-logo-white-testimonial": 676,
	"./logos/pymnts-logo-white-testimonial.png": 676,
	"./logos/pymnts-logo-white.png": 675,
	"./logos/techcrunch-logo-white": 677,
	"./logos/techcrunch-logo-white.png": 677,
	"./logos/westlaw-logo": 382,
	"./logos/westlaw-logo.png": 382,
	"./logos/wsj-black": 678,
	"./logos/wsj-black.jpg": 678,
	"./logos/wsj-logo-black": 383,
	"./logos/wsj-logo-black.png": 383,
	"./logos/wsj-logo-white": 128,
	"./logos/wsj-logo-white-small": 679,
	"./logos/wsj-logo-white-small.png": 679,
	"./logos/wsj-logo-white.png": 128,
	"./logos/xconomy-logo-white": 680,
	"./logos/xconomy-logo-white.png": 680,
	"./marketplace_fund/cover": 681,
	"./marketplace_fund/cover.png": 681,
	"./marketplace_fund/deck-preview-1": 682,
	"./marketplace_fund/deck-preview-1-thumb": 683,
	"./marketplace_fund/deck-preview-1-thumb.png": 683,
	"./marketplace_fund/deck-preview-1.jpg": 682,
	"./marketplace_fund/deck-preview-2": 684,
	"./marketplace_fund/deck-preview-2-thumb": 685,
	"./marketplace_fund/deck-preview-2-thumb.png": 685,
	"./marketplace_fund/deck-preview-2.jpg": 684,
	"./marketplace_fund/deck-preview-3": 686,
	"./marketplace_fund/deck-preview-3-thumb": 687,
	"./marketplace_fund/deck-preview-3-thumb.png": 687,
	"./marketplace_fund/deck-preview-3.jpg": 686,
	"./marketplace_fund/deck-preview-4": 688,
	"./marketplace_fund/deck-preview-4-thumb": 689,
	"./marketplace_fund/deck-preview-4-thumb.png": 689,
	"./marketplace_fund/deck-preview-4.jpg": 688,
	"./marketplace_fund/deck-preview-5": 690,
	"./marketplace_fund/deck-preview-5-thumb": 691,
	"./marketplace_fund/deck-preview-5-thumb.png": 691,
	"./marketplace_fund/deck-preview-5.jpg": 690,
	"./marketplace_fund/hero": 692,
	"./marketplace_fund/hero.png": 692,
	"./plaintiffs/footer": 132,
	"./plaintiffs/footer.jpg": 132,
	"./plaintiffs/hero": 323,
	"./plaintiffs/hero.jpg": 323,
	"./press/abajournal": 693,
	"./press/abajournal.png": 693,
	"./press/banner-prop": 694,
	"./press/banner-prop.png": 694,
	"./press/bloomberg": 695,
	"./press/bloomberg.png": 695,
	"./press/forbes": 696,
	"./press/forbes.png": 696,
	"./press/law360": 697,
	"./press/law360.png": 697,
	"./press/wsj": 698,
	"./press/wsj.png": 698,
	"./raise_capital/court_house_background": 699,
	"./raise_capital/court_house_background.jpg": 699,
	"./raise_capital/cta": 700,
	"./raise_capital/cta.jpg": 700,
	"./raise_capital/dropzone_upload_image": 701,
	"./raise_capital/dropzone_upload_image.png": 701,
	"./raise_capital/hero": 702,
	"./raise_capital/hero.jpg": 702,
	"./shared/banner-prop": 480,
	"./shared/banner-prop.png": 480,
	"./shared/banner-prop.svg": 78,
	"./slip_opinion/slip-opinion-sample": 384,
	"./slip_opinion/slip-opinion-sample.png": 384
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 474;